import { useQuery } from '@tanstack/react-query'
import { apiFetch } from './client'

export interface VapiAssistant {
  id: string
  name: string
}

/** Reasons the backend may return an empty list. Currently only one — surfaced
 *  here so the UI can render an actionable empty state ("contact your
 *  administrator") instead of a generic "no assistants found". An empty list
 *  with no ``reason`` means the org's phone is bound but no outbound
 *  assistants are wired yet — handled reactively via the 403 from
 *  ``POST /vapi/calls/outbound`` rather than a proactive empty state. */
export type AssistantsEmptyReason = 'no_phone_assigned'

export interface ListAssistantsResponse {
  assistants: VapiAssistant[]
  /** Set only when ``assistants`` is empty AND the empty list is a
   *  structural block (e.g. org has no phone yet) rather than an
   *  unconfigured-phone state. */
  reason?: AssistantsEmptyReason
}

export function useAssistants() {
  return useQuery({
    queryKey: ['vapi', 'assistants'],
    queryFn: () => apiFetch<ListAssistantsResponse>('/vapi/assistants'),
    staleTime: 5 * 60_000,
  })
}
